import { ProductBlockDetails } from "../components/ProductBlockDetails/ProductBlock/components/ProductBlockDetails/index.js";
import { ProductBlockFooter } from "../components/ProductBlockFooter/ProductBlock/components/ProductBlockFooter/index.js";
import { ProductBlockHeader } from "../components/ProductBlockHeader/ProductBlock/components/ProductBlockHeader/index.js";
import { ProductBlockImages } from "../components/ProductBlockImages/ProductBlock/components/ProductBlockImages/ProductBlockImages.js";
import { ProductBlockInner } from "../components/ProductBlockInner/ProductBlock/components/ProductBlockInner/ProductBlockInner.js";
import { ProductBlockOuter } from "../components/ProductBlockOuter/ProductBlock/components/ProductBlockOuter/ProductBlockOuter.js";
import { ProductBlockPricing } from "../components/ProductBlockPricing/ProductBlock/components/ProductBlockPricing/ProductBlockPricing.js";
const ProductBlock = Object.assign(
  {},
  {
    Details: ProductBlockDetails,
    Footer: ProductBlockFooter,
    Header: ProductBlockHeader,
    Images: ProductBlockImages,
    Inner: ProductBlockInner,
    Outer: ProductBlockOuter,
    Pricing: ProductBlockPricing
  }
);
export {
  ProductBlock
};
//# sourceMappingURL=index.js.map
